const criteria = {
  department: null,
  process: null,
  datasource: null,
  dataCategory: null,
  data: null,
  datasubject: null,
  minimizationStatus: null,
  receiverGroup: null,
  thirdParty: null,
  methods: null,
};

export const transferingMinimizationFilter = {
  namespaced: true,
  state: {
    criteria: {
      ...criteria,
    },
  },
  getters: {
    criteria: (state) => state.criteria,
  },
  mutations: {
    criteria: (state, value) => (state.criteria = value),

    department: (state, value) => (state.criteria.department = value ? { _id: value._id, name: value.name } : null),
    process: (state, value) => (state.criteria.process = value ? { _id: value._id, name: value.name } : null),
    datasource: (state, value) => (state.criteria.datasource = value ? { _id: value._id, name: value.name } : null),
    dataCategory: (state, value) => (state.criteria.dataCategory = value ? { _id: value._id, name: value.name } : null),
    data: (state, value) => (state.criteria.data = value ? { _id: value._id, name: value.name } : null),
    datasubject: (state, value) => (state.criteria.datasubject = value ? { _id: value._id, name: value.name } : null),
    minimizationStatus: (state, value) => (state.criteria.minimizationStatus = value),
    receiverGroup: (state, value) => (state.criteria.receiverGroup = value),
    thirdParty: (state, value) => (state.criteria.thirdParty = value),
    methods: (state, value) => (state.criteria.methods = value),
    clear: (state, value) => (state.criteria = { ...criteria }),
  },
  actions: {},
};
